<template>
  <div>
    <lazy-hydrate
      v-if="breadcrumbs.length"
      never
    >
      <zg-module>
        <zg-bread-crumb :bread-crumbs="breadcrumbs" />
      </zg-module>
    </lazy-hydrate>
    <lazy-hydrate never>
      <zg-text-section>
        <div slot="body">
          <h1>{{ pageContent.title }}</h1>

          <rich-text
            v-if="pageContent.body && pageContent.body.body"
            :body="pageContent.body.body"
          />
        </div>
      </zg-text-section>
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import RichText from '../components/RichText.vue'

import { ZgModule } from '@zc/components/sections/ZgModule'
import { ZgTextSection } from '@zc/components/sections'

export default {
  name: 'GlossaryPage',
  components: {
    LazyHydrate,
    RichText,
    ZgBreadCrumb: () => import('@zc/components/ZgBreadCrumb/ZgBreadCrumb'),
    ZgModule,
    ZgTextSection
  },
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  computed: {
    breadcrumbs () {
      return this.page.breadcrumbs || []
    },
    pageContent () {
      return this.page.content || {}
    }
  }
}
</script>
